/**
 * 全站用功能
 * Author: Jay Hsu
 * Date: 2023-06-13
 */

 module.exports = {
    default: {
        money: 'TWD'
    },
    money: {
        TWD: {
            mark: 'NT$',
            format: 0
        },
        USD: {
            mark: 'US$',
            format: 2
        },
        AUD: {
            mark: 'A$',
            format: 2
        },
        NZD: {
            mark: 'NZ$',
            format: 2
        },
        CNY: {
            mark: 'RMB￥',
            format: 2
        },
        HKD: {
            mark: 'HK$',
            format: 2
        },
        JPY: {
            mark: '¥',
            format: 0
        },
        KRW: {
            mark: '₩',
            format: 0
        },
        THB: {
            mark: '฿',
            format: 0
        },
        GBP: {
            mark: '£',
            format: 2
        },
        EUR: {
            mark: '€',
            format: 2
        },
    },
    globalEvent() {
        $("#mNavBtn").on('click', () => {
            $("#mobileNav").addClass('show');
            $("body").addClass('mMenuOpen');
        });

        $("#mobileNav .closeBtn").on('click', () => {
            $("#mobileNav").removeClass('show');
            $("body").removeClass('mMenuOpen');
        });

        $('.toTop').on('click touchend', (e) => {
            e.preventDefault();
            $('html,body').animate({
            scrollTop: 0,
            }, 1000)
        });

        //統計用
        $(".statistic").on('click', (e) => {
            //e.preventDefault();
            let $this = $(e.currentTarget);
            this.fnGet({
                url: `${$this.data('api')}?item=${$this.data('item')}&key=${$this.data('key')}`
            });

            return true
        })

        this.topScroll();
        $(window).on('scroll', () => {
            this.topScroll();
        });

        //lazyload
        this.fnLazyload()

        const observer = lozad();
        observer.observe();

        //隱藏Loader
        this.fnLoader(false);

        //開啟 Ajax Form
        $(document).on('click', '.ajax-get', function() {
            //GET
            var req = gfn.fnAJAX($(this));
            req.done((res) => gfn.fnAJAXHandler(res, {
                autoHideModal: false
            }));
        })
        .on('click', '.ajax-post', function() {
            //POST
            var req = gfn.fnAJAX($(this), {
                method: 'POST'
            });
            req.done((res) => gfn.fnAJAXHandler(res, {
                autoHideModal: false
            }));
        })
        .on('click', '.submit', function() {
            $(`form#${$(this).data('form-id')}`).trigger('submit');
        });

        //videoCover by default
        this.fnVideoCover();
    },
    topScroll(){
        if($('html,body').scrollTop() > 0){
            $(".toTop").removeClass('hide')
            $("html,body,header").addClass('scrolldown')
        }else{
            $(".toTop").addClass('hide')
            $("html,body,header").removeClass('scrolldown')
        }
    },
    //基本Fetch get
    fnGet(...rest) {
        const param = Object.assign({
            url: ''
        },...rest)

        return fetch(param.url, {
            headers : {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
    },
    //基本Fetch post
    fnPost(...rest) {
        const param = Object.assign({
            url: '',
            data: {}
        },...rest)

        return fetch(param.url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": $('input[name="_token"]').val()??$('meta[name="csrf-token"]').attr('content')
            },
            method: "post",
            credentials: "same-origin",
            body: JSON.stringify(param.data)
        })
    },
    //create uuid with md5 encode
    fnUUID(){
        return $.md5(Math.random()+(Math.floor(Date.now() / 1000))+Math.random())
    },
    fnLazyload(){
        $(".lazyload").each(function(){
            var original_src = $(this).attr('src')
            $(this)
            .attr('src', window.location.origin+'/img/loading.gif')
            .attr('data-original', original_src)
            .lazyload({effect: "fadeIn"})
        })
    },

    /**
     * promise資料擷取
     * params: url
     * return: promise
     * example:
     * var data1 = promiseGet('https://example.io/sample1.json');
     * var data2 = promiseGet('https://example.io/sample2.json');
     * Promise.all([data1,data2]).then(function(){
     * var newData = [{set1: data1, set2: data2 }];
     * console.log(newData);
     * })
    **/
    promiseGet(URL){
        return new Promise(function(resolve, reject){
            var xhr = new XMLHttpRequest();
            xhr.open('get', URL);
            xhr.send(null);
            xhr.onload = function(){
                resolve(JSON.parse(xhr.responseText));
            }
        });
    },

    /**
     * 格式化文字
     */
    number_format(number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },

    /**
     * currency
     */
    currency(amount, ...rest){
        const param = Object.assign({
            money: this.default.money
        }, ...rest);
        return `${this.money[param.money].mark}${this.number_format(amount, this.money[param.money].format)}`;
    },

    /**
     * ...頁碼
     */
    renderDotDot() {
        //預留筆數
        let config = {
            use: true, //使用
            trigger: 5, //觸發筆數
            keep: 2 //預留筆數
        };

        //符合觸發筆數才執行
        if (this.lastPageValue > config.trigger && config.use){

            //先取出清單
            let pagination = document.querySelectorAll('.pagination .page-item');
            let demoPagerBtn = document.querySelector('.pagination .page-item[data-items-target="pageButton"]');
            let dotPageHref = demoPagerBtn.querySelector('a').getAttribute('href').split('?')[0];

            //製作上頁用...
            let prevDotBtn = demoPagerBtn.cloneNode(true);
            prevDotBtn.querySelector('a').innerHTML = '...';
            prevDotBtn.classList.add('dot_prev');

            //製作下頁用...
            let nextDotBtn = demoPagerBtn.cloneNode(true);
            nextDotBtn.querySelector('a').innerHTML = '...';
            nextDotBtn.classList.add('dot_next');

            //進行頁碼重製
            pagination.forEach(item => {
                let el = item.querySelector('a');
                let page = el.getAttribute('data-items-page-param');
                item.classList.remove('d-none'); //把隱藏的class先移除

                //如果目前葉面大於5，進行大於五的頁碼重製
                if(this.currentPageValue <= config.trigger) {
                    if (page > config.trigger && page <= (this.lastPageValue - config.keep)) {
                        item.classList.add('d-none');
                    }

                }else if(this.currentPageValue > (this.lastPageValue - config.trigger)) {
                    if (page > config.keep && page <= (this.lastPageValue - config.trigger)) {
                        item.classList.add('d-none');
                    }

                //如果小於5，進行小於五的頁碼重製
                }else{
                    //隱藏最前和最後個兩筆頁碼之外的所有頁碼
                    if (page > config.keep && page <= (this.lastPageValue - config.keep)) {
                        item.classList.add('d-none');
                    }

                    //顯示目前頁碼加前後各兩筆
                    if (page <= (this.currentPageValue + config.keep) && page >= (this.currentPageValue - config.keep)) {
                        item.classList.remove('d-none');
                    }
                }

            });

            //置入[...]按鈕
            if (this.lastPageValue > config.trigger){
                let prev = [...pagination].find(item => item.querySelector("a").getAttribute('data-items-page-param') == (config.keep + 1));
                if(document.querySelectorAll('.pagination .dot_prev').length === 0) {
                    document.querySelector('.pagination .page-item').parentNode.insertBefore(prevDotBtn, prev);
                }

                let next = [...pagination].find(item => item.querySelector("a").getAttribute('data-items-page-param') == (this.lastPageValue - config.keep + 1));
                if(document.querySelectorAll('.pagination .dot_next').length === 0) {
                    document.querySelector('.pagination .page-item').parentNode.insertBefore(nextDotBtn, next);
                }
            }

            //判斷[...]出現的時機
            //目前頁面在5以下
            document.querySelector('.pagination .dot_prev').classList.remove('d-none');
            document.querySelector('.pagination .dot_next').classList.remove('d-none');
            if(this.currentPageValue <= config.trigger) {
                document.querySelector('.pagination .dot_prev').classList.add('d-none');

            }else if(this.currentPageValue > (this.lastPageValue - config.trigger)) {
                document.querySelector('.pagination .dot_next').classList.add('d-none');
            }

            //修改上下頁...連結
            let prevDotPage, nextDotPage = 0;
            if(this.currentPageValue > config.trigger && this.currentPageValue < (this.lastPageValue - config.trigger)) {
                prevDotPage = this.currentPageValue - config.keep - 1;
                nextDotPage = this.currentPageValue + config.keep + 1;
            }else{
                prevDotPage = this.lastPageValue - config.trigger - 1;
                nextDotPage = config.trigger + 1;
            }
            document.querySelector('.pagination .dot_prev a').setAttribute('data-items-page-param', prevDotPage);
            document.querySelector('.pagination .dot_prev a').setAttribute('href', `${dotPageHref}?page=${prevDotPage}`);
            document.querySelector('.pagination .dot_next a').setAttribute('data-items-page-param', nextDotPage);
            document.querySelector('.pagination .dot_prev a').setAttribute('href', `${dotPageHref}?page=${nextDotPage}`);
        }
    },

    //開啟表單
    fnOpenModelForm(data) {
        $("#modalForm .modal-dialog").removeClass('modal-sm modal-lg modal-xl').addClass(data.size)
        $("#modalForm .formTitle").empty().html(data.title)
        $("#modalForm .formArea").empty().html(data.form)
        $("#modalForm .formButton").empty().html(data.button)
        $("#modalForm .formButtonLeft").empty().html(data.left_button)
        $("#modalForm").modal("show")
        $("#modalForm .formArea").scrollTop(0)
    },

    //資料送出成功
    fnSuccess(res, hideform = true) {
        if (hideform) $("#modalForm").modal("hide")
        $("#bModal .modal-title").text(`執行成功`)
        $("#message").html(
            `<div class="alert alert-success text-center">${res.msg}</div>`
        )
        $("#bModal").modal("show")
    },

    //製作按鈕
    fnCreateButtonSet(data) {
        let buttons = data.button
        let button_html = ''
        for(prop in buttons) {
            let button = buttons[prop]
            button_html += `<button class="btn btn-primary ml-1 ${button.type}"
            data-uri="${button.uri}"
            data-form-id="${data.form_id}"
            >${button.text}</button>`
        }
        return button_html
    },

    //資料送出失敗
    fnFail(res, hideform = true) {
        if (hideform) $("#modalForm").modal("hide")
        $("#bModal .modal-title").text(`送交未成功提示訊息`)
        $("#message").html(
            `<div class="alert alert-danger text-center">${res.msg}</div>`
        )
        $("#bModal").modal("show")
    },

    //顯示載入效果
    fnLoader(event) {
        if (event) {
            $(".ajax-loader").addClass("show").addClass("d-flex").show()
        } else {
            $(".ajax-loader").removeClass("show").removeClass("d-flex").hide()
        }
    },

    //延遲載入fnLoader效果，回傳Promise
    //event: true(開啟) false(關閉)
    //delay: 延遲毫秒
    fnLoaderDelay(event, delay) {
        return new Promise((resolve, reject) => {
            //處理延遲時間
            setTimeout(()=>{
                //進行動畫
                gfn.fnLoader(event);

                //回傳成功
                resolve();
            }, delay);
        });
    },

    //取資料
    fnGetData(id) {
        return $(`#${id}`).serializeJSON()
    },

    //資料驗證失敗
    fnValidateFail(res, hideform = true) {
        let validate_result = '<ul class="list-group list-group-flush">'
        for (let item in res.data) {
            for (let sub in res.data[item]) {
                validate_result += `<li class="list-group-item">
                        <i class="fa fa-ban text-danger"></i>
                        ${ this.convertFieldName(res.field_name, res.data[item][sub]) }
                    </li>`
            }
        }
        validate_result += `</ul>`
        if (hideform) $("#modalForm").modal("hide")
        $("#bModal .modal-title").text(`資料有誤[${res.code}]`)
        $("#message").html(
            `<div class="alert alert-danger text-center">${res.msg}</div>${validate_result}`
        )
        $("#bModal").modal("show")
    },

    //轉換欄位名稱
    convertFieldName(name_set, msg) {
        //回傳過來的因為是一段字串，需要解析，拆陣列後的第一個元素為欄位name
        let key = msg.split(' ')[0];

        //將驗證訊息的name元素過濾掉
        let error_msg = msg.replace(key, '');

        //如果沒有欄位對照名稱資料，直接回傳key
        if (!name_set || name_set === undefined) return msg;

        //如果沒有對照欄位名稱，直接回傳key
        if(!name_set[key] || name_set === undefined) return msg;

        //如果有對照資料，回傳對照值
        return name_set[key] + error_msg;
    },

    //基本AJAXCALL
    fnAJAX($obj, ...rest) {
        const param = Object.assign({
            method: 'GET',
            url: $obj.data('uri'),
            dataType: 'JSON',
            data: this.fnGetData($obj.data('form-id'))??{}
        },...rest);

        return $.ajax({
            type: param.method,
            url: param.url,
            dataType: param.dataType,
            data: param.data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            },
            beforeSend: (xhr, type) => {
                this.fnLoader(true)
            },
            error: (e) => {
                this.fnLoader(false);
                Swal.fire({
                    icon: 'error',
                    title: '哎呀! 出問題了!',
                    text: `很抱歉! 您的操作出了點問題，請重整後再嘗試`
                });
            }
        })
    },

    //ajax handler
    fnAJAXHandler(res, ...rest) {
        const param = Object.assign({
            method: 'get',
            success: false,
            fail: false,
            autoHideModal: true,
            successMsg: false,
        },...rest)

        this.fnLoader(false)
        switch(param.method){
            case 'send':
                if (res.code === 0) {
                    if (!param.success) {
                        this.fnSuccess(res)
                    }else{
                        this.fnSuccess(res)
                        param.success(res)
                    }
                } else if (res.code === 2) {
                    if (!param.success) {
                        this.fnValidateFail(res, false)
                    }else{
                        this.fnValidateFail(res, false)
                        if (param.fail) param.fail(res)
                    }
                } else if (res.code === 10) {
                    this.fnOpenModelForm(res.data)
                } else {
                    if (!param.success) {
                        this.fnFail(res, false)
                    }else{
                        this.fnFail(res, false)
                        if (param.fail) param.fail(res)
                    }
                }
                break
            default:
                if (res.code === 0) {
                    if (param.successMsg) this.fnSuccess(res, param.autoHideModal)
                    this.fnOpenModelForm(res.data)
                    if (param.success) param.success(res)
                } else if (res.code === 2) {
                    if (!param.success) {
                        this.fnValidateFail(res, false)
                    }else{
                        this.fnValidateFail(res, false)
                    }
                } else if (res.code === 10) {
                    this.fnOpenModelForm(res.data)
                } else {
                    if (!param.success) {
                        this.fnFail(res, param.autoHideModal)
                    }else{
                        this.fnFail(res, param.autoHideModal)
                        if (param.fail) param.fail(res)
                    }
                }
                break
        }

    },
    //轉換qrcode
    fnCreateQrcode() {
        $(".qrcode").each(function() {
            $(this).empty().qrcode($(this).attr("data-id"))
        })
    },
    //videoCover
    fnVideoCover(){
        //影片背景
        $(".video-cover").each(function(){
            calcVideoRatio(this);
        });
        $(window).on('resize',function(){
            $(".video-cover").each(function(){
                calcVideoRatio(this);
            });
        })

        //計算影片比例
        function calcVideoRatio($this){
            let video = {
                width: $($this).data('width'),
                height: $($this).data('height')
            };
            let wrap = {
                width: $($this).width(),
                height: $($this).height()
            };
            let set = {
                width: 0,
                height: 0,
                top:0,
                left:0,
            };

            video.ratio = video.width/video.height;
            wrap.ratio = wrap.width/wrap.height;

            if (video.ratio > wrap.ratio){
                set.width = wrap.height*video.ratio;
                set.height = wrap.height;
                set.left = -((set.width - wrap.width)/2);
            }else{
                set.width = wrap.width;
                set.height = wrap.width*(video.height/video.width);
                set.top = -((set.height - wrap.height)/2);
            }

            $('.video-iframe', $this)
            .width(set.width)
            .height(set.height)
            .css({
                top: `${set.top}px`,
                left: `${set.left}px`,
            });

            // console.log(video.ratio);
            // console.log(wrap.ratio);
        }
    }
 }
